export const learnMoreStyle = ({ palette = {} }) => ({
  '& .HelpTopic': {
    padding: 0,
    border: 'none',
    color: palette.themePrimary,
    background: 'none',
    textDecoration: 'underline',
  },
});
